import _ from 'underscore'
import DateFrom from '../../../models/date-from'
import ReportingView from '../../../views/reporting'
import titles from '../../../titles'

const FrpReportingView = ReportingView.extend({
    initialize() {
        this.template = _.template(`
            <div id="main-view">
                <div id="nav-view"></div>
                <div id="header-view"></div>
                <div id="sub-view">
                    <div id="reporting-view">
                        <div class="title">
                            Reporting
                            <select class="change-date-from">
                                <option value="lastWeek">Last Week</option>
                                <option value="lastMonth">Last Month</option>
                                <option value="last6Months">Last 6 Months</option>
                                <option value="last12Months">Last 12 Months</option>
                            </select>
                        </div>
                        <div class="results scrollable">
                            <table class="results-table">
                                <tr>
                                    <th>Title</th>
                                    <th>Stars</th>
                                    <th>Completed</th>
                                    <th>Fluency</th>
                                    <th>Reasoning</th>
                                    <th>Problem Solving</th>
                                    <th>Overall</th>
                                </tr>
                            </table>
                        </div>
                        <ul class="student"></ul>
                    </div>
                </div>
            </div>
        `)

        // this is where we sort the dateFrom value
        this.dateFrom = new DateFrom()

        // By default it requests the results from the last seven days
        this.lastWeek()

        // Listen for changes in the titles collection:
        // - "reset" fires when you call collection.reset([...])
        // - "update" fires on add/remove
        // - "change" fires when a model's attributes change
        this.listenTo(titles, 'reset update change', this.render)
    },
})

export default FrpReportingView
